import {
  Compass,
  MessageCircle,
  LayoutDashboard,
  FolderKanban,
  CheckSquare,
  Users,
  Rss,
  ArrowRightLeft,
  FileText,
  UserCircle,
  Settings,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

export const coreNavItems: NavItem[] = [
  { to: '/navigator', label: 'Navigator', icon: Compass },
  { to: '/navigator-chat', label: 'Chat', icon: MessageCircle },
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/projects', label: 'Projects', icon: FolderKanban },
  { to: '/my-tasks', label: 'My Tasks', icon: CheckSquare },
];

export const toolsNavItems: NavItem[] = [
  { to: '/users', label: 'Users', icon: Users },
  { to: '/feed', label: 'Feed', icon: Rss },
  { to: '/migration', label: 'Migration', icon: ArrowRightLeft },
  { to: '/logs', label: 'Logs', icon: FileText },
];

export const allNavItems: NavItem[] = [...coreNavItems, ...toolsNavItems];

export const userNavItems: NavItem[] = [
  { to: '/profile', label: 'Profile', icon: UserCircle },
  { to: '/settings', label: 'Settings', icon: Settings },
];
